import React, { useCallback, FC, useState, useEffect } from 'react';

import { IGroupEnrollment, IGroupGameGame, IHole } from '../../../../../store/player/games/store';
import { IEventItem } from '../../../../../store/player/events/store';

import moneyBallIcon from '../../../../../assets/images/players_scoring_tabs_icons/icon-money_ball-not_selected.svg';
import { IDraft } from '../Utils/IDraft';
import ScorePicker from '../../Components/ScorePicker/ScorePicker';
import Scorer from '../../Components/Scorer';

interface IProps {
  draftScores: IDraft;
  editMode: boolean;
  enrollment: IGroupEnrollment;
  event: IEventItem | undefined;
  groupGames: IGroupGameGame[];
  hole: IHole | undefined;
  seat: number;
  setScore: (enrollmentId: number) => (value: number) => void;
}

const HoleScorerIndividual: FC<IProps> = props => {
  const { setScore, hole, event, groupGames, editMode, enrollment, draftScores, seat } = props;

  const [gross, setGross] = useState(0);
  const [scorePickerIsDisabled, setScorePickerIsDisabled] = useState(false);

  const displayMoneyBallIcon = useCallback(
    (selectedSeat: number) => {
      if (!hole || !event) {
        return false;
      }

      const eventIsMoneyBall = Object.values(event.formats).some(format =>
        format.format.prefix.includes('money')
      );

      if (!eventIsMoneyBall) {
        return false;
      }

      return selectedSeat === hole.order % groupGames.length;
    },
    [hole, groupGames, event]
  );

  useEffect(() => {
    const score = draftScores[enrollment.id];

    if (score) {
      const scoreOriginal = score.original;
      const scoreGross = score.gross;
      const scoreNotSaved = score.notSaved;

      if (scoreOriginal !== scoreGross && !scoreNotSaved) {
        setGross(scoreGross);
        setScorePickerIsDisabled(true);
      } else {
        setGross(scoreOriginal);
      }
    }
  }, [draftScores, enrollment]);

  return (
    <Scorer item={enrollment} key={`scorer-${enrollment.id}`}>
      <ScorePicker
        editMode={editMode}
        empty={!draftScores[enrollment.id] || draftScores[enrollment.id].empty}
        gross={gross}
        net={draftScores[enrollment.id] ? draftScores[enrollment.id].netScore : 0}
        onChange={setScore(enrollment.id)}
        par={hole ? hole.par : 0}
        notSaved={draftScores[enrollment.id] ? draftScores[enrollment.id].notSaved : false}
        disabled={scorePickerIsDisabled}
      />

      <div className="moneyball-indicator">
        {displayMoneyBallIcon(seat) && <img src={moneyBallIcon} className="logo" alt="logo" />}
      </div>
    </Scorer>
  );
};

export default HoleScorerIndividual;
